// extracted by mini-css-extract-plugin
export default {"icon":"TopicTreeCardPostIcon-module__icon--WeUPI","movedOut":"TopicTreeCardPostIcon-module__movedOut--MRk_V","template":"TopicTreeCardPostIcon-module__template--Y1CS6"};